import { BaseUseCase } from "../UseCaseBase";
export class FaqUseCase extends BaseUseCase {
    constructor(FooterRepository) {
        super();
        this.FooterRepository = FooterRepository;
    }
    async fetchResult(data) {
        return await this.FooterRepository.getFaqMasterData();
    }
}
